module.exports = __webpack_public_path__ + "static/media/tik-tok.e30e4714.png";